// extracted by mini-css-extract-plugin
module.exports = {"subscriptions":"styles_subscriptions__31n8n"};